'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTextareaAutosize = require('react-textarea-autosize');

var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);

var _FieldButtons = require('./FieldButtons');

var _FieldButtons2 = _interopRequireDefault(_FieldButtons);

var _FieldHelp = require('./FieldHelp');

var _FieldHelp2 = _interopRequireDefault(_FieldHelp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Manage help text.
// Bubble hasError (and value?) up.

function EditField(props) {
  var className = props.className,
      description = props.description,
      hasError = props.hasError,
      errorMessage = props.errorMessage,
      id = props.id,
      onChange = props.onChange,
      onClose = props.onClose,
      preventClose = props.preventClose,
      showButtons = props.showButtons,
      suggestion = props.suggestion,
      type = props.type,
      value = props.value;


  var helpTxt = hasError ? errorMessage : description;
  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'div',
      { className: 'editable-row' },
      type !== 'textarea' && _react2.default.createElement('input', { id: id, type: type, onChange: onChange, value: value || '' }),
      type === 'textarea' && _react2.default.createElement(_reactTextareaAutosize2.default, {
        className: 'form-control',
        id: id,
        onChange: onChange,
        value: value
      }),
      showButtons && _react2.default.createElement(_FieldButtons2.default, {
        disabled: hasError,
        onClose: onClose,
        preventClose: preventClose
      })
    ),
    (helpTxt || suggestion) && _react2.default.createElement(_FieldHelp2.default, {
      help: helpTxt,
      hasErrors: hasError,
      id: id,
      suggestion: suggestion
    })
  );
}

EditField.propTypes = {
  className: _propTypes2.default.string,
  description: _propTypes2.default.string,
  errorMessage: _propTypes2.default.string,
  hasError: _propTypes2.default.bool.isRequired,
  id: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  preventClose: _propTypes2.default.bool,
  showButtons: _propTypes2.default.bool.isRequired,
  suggestion: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(['email', 'dateTime', 'fullName', 'select', 'text', 'textarea', 'url']).isRequired,
  value: _propTypes2.default.string
};
EditField.defaultProps = {
  showButtons: true
};
exports.default = EditField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/Editable/FieldEditEl.js
// module id = 669
// module chunks = 0